import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Network as NetworkIcon, Plus, Info } from "lucide-react";

export default function NetworksPanel({ open, onClose, value, onSave, scannedSubnets }) {
  const [text, setText] = useState(value || "");

  useEffect(() => {
    if (open) setText(value || "");
  }, [open, value]);

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 z-30 bg-black/20 backdrop-blur-[2px]"
            data-testid="networks-overlay"
          />
          <motion.div
            initial={{ scale: 0.94, opacity: 0, y: 10 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.94, opacity: 0, y: 10 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            dir="rtl"
            className="absolute left-1/2 top-1/2 z-40 w-[440px] max-w-[calc(100vw-2rem)] -translate-x-1/2 -translate-y-1/2 rounded-2xl border border-white/60 bg-white/90 p-5 shadow-2xl backdrop-blur-xl"
            data-testid="networks-panel"
          >
            <div className="mb-4 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <NetworkIcon size={18} className="text-[#0055FF]" />
                <h2 className="text-[15px] font-bold text-[#0A0A0A]">רשתות לסריקה</h2>
              </div>
              <button
                data-testid="networks-close"
                onClick={onClose}
                className="rounded-lg p-1 text-[#52525B] transition-colors hover:bg-black/5"
              >
                <X size={18} />
              </button>
            </div>

            <p className="mb-3 text-[12px] leading-relaxed text-[#52525B]">
              המערכת סורקת אוטומטית את כל הרשתות שהמחשב מחובר אליהן. כדי לסרוק גם את
              הרשתות של ראוטרים נוספים, הוסף כאן את טווחי הרשת שלהם (CIDR), אחד בכל שורה.
            </p>

            <textarea
              data-testid="networks-input"
              value={text}
              onChange={(e) => setText(e.target.value)}
              dir="ltr"
              placeholder={"192.168.2.0/24\n10.0.0.0/24"}
              className="h-28 w-full resize-none rounded-xl border border-black/10 bg-white p-3 font-mono text-[13px] text-[#0A0A0A] outline-none focus:border-[#0055FF] focus:ring-2 focus:ring-[#0055FF]/20"
            />

            <div className="mt-2 flex items-start gap-1.5 text-[11px] text-[#94A3B8]">
              <Info size={13} className="mt-0.5 shrink-0" />
              <span>
                טיפ: מכשירים מאחורי ראוטר שעושה NAT יזוהו רק אם הוא במצב Access Point,
                או אם המחשב מחובר גם לרשת הזו.
              </span>
            </div>

            {scannedSubnets?.length > 0 && (
              <div className="mt-4">
                <p className="mb-1.5 text-[11px] font-semibold text-[#0A0A0A]">
                  נסרקות כעת:
                </p>
                <div className="flex flex-wrap gap-1.5" dir="ltr">
                  {scannedSubnets.map((s) => (
                    <span
                      key={s}
                      className="rounded-md bg-[#0055FF]/10 px-2 py-0.5 font-mono text-[11px] font-medium text-[#0055FF]"
                    >
                      {s}
                    </span>
                  ))}
                </div>
              </div>
            )}

            <div className="mt-5 flex justify-end gap-2">
              <button
                onClick={onClose}
                className="rounded-xl px-4 py-2 text-[13px] font-semibold text-[#52525B] transition-colors hover:bg-black/5"
              >
                ביטול
              </button>
              <button
                data-testid="networks-save"
                onClick={() => onSave(text)}
                className="flex items-center gap-2 rounded-xl bg-[#0055FF] px-4 py-2 text-[13px] font-semibold text-white shadow-md transition-colors hover:bg-[#0047d6]"
              >
                <Plus size={15} />
                שמור וסרוק
              </button>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
